import { useEffect, useState } from 'react';
import ExcursionService from '../../repository/tourRepository/ExcursionRepository';
import AddEditExcursionModal from './AddEditExcursionModal';
import ExcursionTerm from './ExcursionTerm';
import '../../App.css';
import { strings } from '../../localization/Localization';
import Swal from 'sweetalert2';
import { useAuth } from '../Auth/AuthContext';
import ClientOnExcursionService from '../../repository/clientOnExcursionRepository/ClientOnExcursionRepository';

const Excursions = () => {
  const [excursions, setExcursions] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchInput, setSearchInput] = useState('');
  const [sortField, setSortField] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');
  const { isAdmin } = useAuth();

  useEffect(() => {
    getExcursions();
  }, [page, pageSize, sortField, sortOrder]);

  const getExcursions = () => {
    ExcursionService.getAllExcursions(page, pageSize, sortField, sortOrder, searchInput)
      .then((data) => {
        setExcursions(data.data.content);
        setTotalPages(data.data.totalPages);
      })
      .catch((error) => {
        console.error('Error fetching excursions:', error);
      });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(0);
    getExcursions();
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value) || 5;
    setPageSize(newSize);
    setPage(0);
  };

  const handleSortChange = (e) => {
    e.preventDefault();
    getExcursions();
  };

  const handleExport = () => {
    ExcursionService.exportExcursions()
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'excursions.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        Swal.fire({
          icon: 'success',
          title: strings.exportSuccessful,
        });
      })
      .catch((error) => {
        console.error('Error exporting excursions:', error);
        Swal.fire({
          icon: 'error',
          title: strings.exportFailed,
          text: strings.failedToExport
        });
      });
  };

  const handleFullExport = () => {
    ClientOnExcursionService.fullExport()
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'client-excursions.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        Swal.fire({
          icon: 'success',
          title: strings.exportSuccessful,
        });
      })
      .catch((error) => {
        console.error('Error exporting client excursions:', error);
        Swal.fire({
          icon: 'error',
          title: strings.exportFailed,
          text: strings.failedToExport
        });
      })
  };

  return (
    <div className={'container mt-3'}>
      <AddEditExcursionModal
        showModal={showAddModal}
        handleClose={() => setShowAddModal(false)}
        getExcursions={getExcursions}
      />
      <h2 className={'text-center mt-4'}>{strings.excursions}</h2>
      <hr className={'mt-0'}/>
      <div className={'d-flex flex-wrap'}>
        <div className={'mt-3 me-2'}>
          <form className='d-flex form-inline my-1 my-lg-0' onSubmit={handleSearch}>
            <input
              className='form-control mr-sm-2'
              type='search'
              placeholder={strings.search}
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button className='btn btn-outline-secondary my-2 my-sm-0' type='submit'>
              {strings.search}
            </button>
          </form>
        </div>
        <div className={'mt-3'}>
          <form className='d-flex form-inline my-1 my-lg-0' onSubmit={handleSortChange}>
            <div className='position-relative mr-1'>
              <select
                className='form-control custom-select mr-1'
                value={sortField}
                onChange={(e) => setSortField(e.target.value)}
              >
                <option value='name'>{strings.excursionId}</option>
                <option value='name'>{strings.name}</option>
                <option value='placeTo'>{strings.placeTo}</option>
                <option value='dateFrom'>{strings.dateFrom}</option>
                <option value='price'>{strings.price}</option>
              </select>
            </div>
            <div className='position-relative mr-2'>
              <select
                className='form-control custom-select mr-2'
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
              >
                <option value='asc'>{strings.ascending}</option>
                <option value='desc'>{strings.descending}</option>
              </select>
            </div>
            <button className='btn btn-outline-secondary my-2 my-sm-0' type='submit'>
              {strings.sort}
            </button>
          </form>
        </div>
        <div className={'ms-2 mt-3 d-flex'}>
          <span className={'text-secondary mt-1'}>{strings.paginationSize} </span>
          <input
            className='form-control mx-2'
            type='number'
            min='1'
            placeholder='Page Size'
            value={pageSize}
            onChange={handlePageSizeChange}
            style={{ width: '50px' }}
          />
        </div>
        <div className={'ms-auto d-flex'}>
          {isAdmin && (
           <>
             <button
               className={'d-flex ms-auto mt-3 me-2 btn btn-danger px-3 rounded-4'}
               onClick={handleExport}
             >
               {strings.export}
             </button>
             <button
               className={'d-flex ms-auto mt-3 me-2 btn btn-danger px-3 rounded-4'}
               onClick={handleFullExport}
             >
               {strings.fullExport}
             </button>
           </>
          )}
          <button
            className={'d-flex ms-auto mt-3 btn btn-primary px-3 rounded-4'}
            onClick={() => setShowAddModal(true)}
          >
            {strings.addNewExcursion}
          </button>
        </div>
      </div>
      <table className={'table user-table table-responsive table-borderless table-striped mb-1 mt-3'}>
        <thead className={'table-header-css'}>
        <tr className={'rounded-4'}>
          <th scope={'col'}>{strings.excursionId}</th>
          <th scope={'col'}>{strings.name}</th>
          <th scope={'col'}>{strings.placeTo}</th>
          <th scope={'col'}>{strings.dateFrom}</th>
          <th scope={'col'}>{strings.dateTo}</th>
          <th scope={'col'}>{strings.price}</th>
          <th scope={'col'}>{strings.discount}</th>
          <th scope={'col'}>{strings.totalSeats}</th>
          <th scope={'col'}>{strings.bookedSeats}</th>
          {isAdmin && (
            <th scope={'col'}>{strings.actions}</th>
          )}
        </tr>
        </thead>
        <tbody>
        {excursions.length > 0 ? (
          excursions.map((excursion, index) => (
            <ExcursionTerm
              excursion={excursion}
              key={index}
              getExcursions={getExcursions}
              handleClose={() => setShowAddModal(false)}
              showModal={showAddModal}
            />
          ))
        ) : (
          <tr>
            <td colSpan='12' className={'text-center my-5'}>
              <i className={'text-secondary no-notification-message'}>{strings.noExcursions}</i>
            </td>
          </tr>
        )}
        </tbody>
      </table>
      <div className='my-2 d-flex justify-content-center gap-2'>
        <button
          disabled={page === 0}
          onClick={() => setPage(page - 1)}
          className={`px-3 py-2 rounded font-bold transition ${
            page === 0 ? 'bg-light-gray color-dark-blue text-muted cursor-not-allowed' : 'bg-dark-blue text-white hover:opacity-80'
          }`}
        >
          ← {strings.previous}
        </button>
        <span className='color-dark-blue font-bold mt-2'>
        {strings.page} {page + 1} {strings.of} {totalPages}
        </span>
        <button
          disabled={page + 1 >= totalPages}
          onClick={() => setPage(page + 1)}
          className={`px-3 py-2 rounded font-bold transition ${
            page + 1 >= totalPages ? 'bg-light-gray color-dark-blue text-muted cursor-not-allowed' : 'bg-dark-blue text-white hover:opacity-80'
          }`}
        >
          {strings.next} →
        </button>
      </div>
    </div>
  );
};

export default Excursions;